import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import drcRatings from "../../../../src/data/articles/cube-prospective-aetherdrift-commander/drc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  drcRatings,
  ProspectiveIntro,
  React
};